// extracted by mini-css-extract-plugin
module.exports = {"free-sound-packs":"free-sound-packs-all_free-sound-packs__Yqs8l","free-sound-packs__header":"free-sound-packs-all_free-sound-packs__header__3KTk4"};